<script>
import { authComputed } from "@/state/helpers";

export default {
  components: {},
  props: {
    currentProps: Object,
    customQuestionProps: Array,
  },
  data() {
    return {};
  },
  computed: {
    ...authComputed,
  },
  mounted() {},
  methods: {},
};
</script>

<template>
  <b-tab>
    <template v-slot:title>
      <span class="d-inline-block d-sm-none">
        <i class="fas fa-home"></i>
      </span>
      <span class="d-none d-sm-inline-block">Questionnaire</span>
    </template>
    <b-card no-body class="shadow-none">
      <b-card-body>
        <b-card-text>
          <div
            class="row"
            v-for="(customQuestion, index) in customQuestionProps"
            :key="index"
          >
            <div class="col-12">
              <b-card header-class="bg-transparent " class="border">
                <h5 class="card-title mt-0">
                  {{ index + 1 }}.
                  {{ customQuestion.question_text }}
                  <span class="text-danger" v-if="customQuestion.is_required"
                    >*</span
                  >
                </h5>
                <div
                  class="row"
                  v-if="
                    customQuestion.answer_type == 'date' ||
                    customQuestion.answer_type == 'time' ||
                    customQuestion.answer_type == 'number' ||
                    customQuestion.answer_type == 'time' ||
                    customQuestion.answer_type == 'phone' ||
                    customQuestion.answer_type == 'email' ||
                    customQuestion.answer_type == 'text' ||
                    customQuestion.answer_type == 'file'
                  "
                >
                  <div class="col-md-12">
                    <input
                      :id="String(index)"
                      :type="customQuestion.answer_type"
                      class="form-control form-control-sm"
                      :value="customQuestion.answer_text"
                      :required="customQuestion.is_required"
                      readonly
                    />
                  </div>
                </div>
                <div
                  class="row card-text"
                  v-if="customQuestion.answer_type == 'textarea'"
                >
                  <div class="col-md-12">
                    <textarea
                      :id="String(index)"
                      class="form-control form-control-sm"
                      cols="5"
                      :required="customQuestion.is_required"
                      rows="5"
                      readonly
                      v-model="customQuestion.answer_text"
                    ></textarea>
                  </div>
                </div>
                <div
                  class="row card-text"
                  v-if="customQuestion.answer_type == 'radio'"
                >
                  <div class="col-md-12">
                    <b-form-group>
                      <b-form-radio
                        :id="'' + index + ''"
                        class="mb-2"
                        value="a"
                        name="selectOption"
                        plain
                        readonly
                        >Yes</b-form-radio
                      >
                      <b-form-radio
                        :id="'' + index + ''"
                        name="selectOption"
                        value="b"
                        plain
                        readonly
                        >No</b-form-radio
                      >
                    </b-form-group>
                  </div>
                </div>
                <div
                  class="row card-text"
                  v-if="
                    customQuestion.answer_type == 'multi_select' ||
                    customQuestion.answer_type == 'choice'
                  "
                >
                  <div
                    class="col-md-12"
                    v-for="(customCheckbox, cIndex) in customQuestion.form_data"
                    :key="cIndex"
                  >
                    <b-form-checkbox
                      :id="String(cIndex)"
                      value="accepted"
                      unchecked-value="not_accepted"
                      class="mb-2"
                      checked
                      plain
                      readonly
                      >{{ customCheckbox.option }}</b-form-checkbox
                    >
                  </div>
                </div>
              </b-card>
            </div>
          </div>
        </b-card-text>
      </b-card-body>
    </b-card>
  </b-tab>
</template>
